import * as React from 'react'

import { Animate, BottomContainer, HeaderPlaceholder, TopContainer, useHelloBar } from './common'

import CarebuzzFooter from 'app/components/CarebuzzFooter'
import CarebuzzTopMenu from 'app/components/CarebuzzTopMenu'
import ClientOnly from 'app/components/ClientOnly'
import HelloBarBlock from 'app/components/CustomBlocks/component/HelloBarBlock'
import useHasMounted from 'app/hooks/use-has-mounted'

const CarebuzzLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { showHelloBar, helloBarBlockData } = useHelloBar('honeygain-components/carebuzz-hello-bar')
  const hasMounted = useHasMounted()

  return (
    <>
      {hasMounted ? (
        <TopContainer>
          {showHelloBar && (
            <Animate $height="64px" className="hello-bar-container">
              <HelloBarBlock {...(helloBarBlockData as any)} />
            </Animate>
          )}

          <CarebuzzTopMenu />
        </TopContainer>
      ) : (
        <HeaderPlaceholder />
      )}
      {children}
      <ClientOnly>
        <CarebuzzFooter />
      </ClientOnly>
      {showHelloBar && (
        <BottomContainer>
          <Animate $height="200px">
            <HelloBarBlock {...(helloBarBlockData as any)} />
          </Animate>
        </BottomContainer>
      )}
    </>
  )
}

export default CarebuzzLayout
